import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  country: z.string().optional(),
  companyCountry: z.string().optional(),
  role: z.string().optional(),
  exp: z.string().optional(),
  min: z.coerce.number().optional(),
  avg: z.coerce.number().optional(),
  max: z.coerce.number().optional(),
})

export const Route = createFileRoute('/$locale/dashboard/salary-negotiation')({
  validateSearch: searchSchema,
})
